
interface DedicatedStatusQuestion {
    key: string;
    questionText: string;
}

export const DedicatedStatusQuestionConstants: Record<string, DedicatedStatusQuestion> = {
    question1: {
        key: 'question1',
        questionText: 'I understand that the process of attaining dedicated status with Natshoot (NHSA) is a legally prescribed process to which both the NHSA and myself have to adhere to as it has direct bearing on my continued legal possession of firearms.'
    },
    question2_hunting: {
        key: 'question2_hunting',
        questionText: 'I regularly or will regularly, and in a dedicated manner, participate in Hunting and related activities with my Hunting firearms.'
    },
    question2_sport: {
        key: 'question2_sport',
        questionText: 'I regularly or will regularly, and in a dedicated manner, participate in Sport-Shooting and related activities with my Sport-Shooting firearms.'
    },
    question3: {
        key: 'question3',
        questionText: 'I understand that the annual maintenance of my dedicated status with Natshoot (NHSA) is entirely my own responsibility, and that I have no claim against the NHSA, any of its affiliates or associates or any of its personnel whatsoever, should I lose my dedicated status because of non-compliance with any of the by Law prescribed processes due to my actions or the lack thereof.'
    },
    question4: {
        key: 'question4',
        questionText: 'I know and understand that in terms of the FCA (Act 60 of 2000) and its Regulations (2004), I may not conduct any PH related work with the firearms I have licensed based on my Dedicated Hunter Status with Natshoot (NHSA).'
    }
};